import { sendBiEvent as publicSendBiEvent } from './devcenter-bi-events-v1-send-bi-event-response-bi-events.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const sendBiEvent: MaybeContext<
  BuildRESTFunction<typeof publicSendBiEvent> & typeof publicSendBiEvent
> = /*#__PURE__*/ createRESTModule(publicSendBiEvent);

export { EventName } from './devcenter-bi-events-v1-send-bi-event-response-bi-events.universal.js';
export {
  SendBIEventResponse,
  SendBIEventRequest,
  SendBiEventOptions,
} from './devcenter-bi-events-v1-send-bi-event-response-bi-events.universal.js';
export { EventNameWithLiterals } from './devcenter-bi-events-v1-send-bi-event-response-bi-events.universal.js';
